import { type FC } from 'react';
import {
  Chalkboard
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconChalkboardProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconChalkboard: FC<UiIconChalkboardProps> = (props) => {
  return (
    <UiIcon
      IconComponent={Chalkboard}
      {...props}
    />
  );
};
